import script from "./AcadmyPickPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AcadmyPickPage.vue?vue&type=script&setup=true&lang=js"

import "./AcadmyPickPage.vue?vue&type=style&index=0&id=f8607058&lang=scss"

const __exports__ = script;

export default __exports__